import { ClassDefinitionContract, RaceDefinitionContract } from '@dndbeyond/character-rules-engine/es';

import { builderActionTypes } from '../builder';
import {
    BuilderMethodSetAction,
    BuilderMethodSetActionPayload,
    BuilderMethodSetCommitAction,
    CharacterLoadedSetCommitAction,
    CharacterLoadingSetCommitAction,
    CharacterLoadRequestAction,
    ConfirmClassSetAction,
    ConfirmRaceSetAction,
    ExportPdfAction,
    PdfUrlSetAction,
    QuickBuildRequestAction,
    RandomBuildRequestAction,
    ShowHelpTextSetAction,
    StepBuildRequestAction,
} from './typings';

export function characterLoadRequest(): CharacterLoadRequestAction {
    return {
        type: builderActionTypes.CHARACTER_LOAD_REQUEST,
        payload: {},
    };
}

export function quickBuildRequest(
    entityRaceId: number | null,
    entityRaceTypeId: number | null,
    classId: number | null,
    name: string | null,
): QuickBuildRequestAction {
    return {
        type: builderActionTypes.QUICK_BUILD_REQUEST,
        payload: {
            entityRaceId,
            entityRaceTypeId,
            classId,
            name,
        },
    };
}

export function randomBuildRequest(
    level: number | null,
    entityRaceId: number | null,
    entityRaceTypeId: number | null,
    classId: number | null,
    allowMulticlass: boolean,
    allowFeats: boolean,
    name: string | null,
): RandomBuildRequestAction {
    return {
        type: builderActionTypes.RANDOM_BUILD_REQUEST,
        payload: {
            level,
            entityRaceId,
            entityRaceTypeId,
            classId,
            allowMulticlass,
            allowFeats,
            name,
        },
    };
}

export function stepBuildRequest(showHelpText: boolean): StepBuildRequestAction {
    return {
        type: builderActionTypes.STEP_BUILD_REQUEST,
        payload: {
            showHelpText,
        },
    };
}

export function characterLoadingSetCommit(isLoading: boolean): CharacterLoadingSetCommitAction {
    return {
        type: builderActionTypes.CHARACTER_LOADING_SET_COMMIT,
        payload: {
            isLoading,
        },
    };
}

export function characterLoadedSetCommit(isLoaded: boolean): CharacterLoadedSetCommitAction {
    return {
        type: builderActionTypes.CHARACTER_LOADED_SET_COMMIT,
        payload: {
            isLoaded,
        },
    };
}

export function showHelpTextSet(showHelpText: boolean): ShowHelpTextSetAction {
    return {
        type: builderActionTypes.SHOW_HELP_TEXT_SET,
        payload: {
            showHelpText,
        },
    };
}

export function builderMethodSet(method: string): BuilderMethodSetAction {
    return {
        type: builderActionTypes.BUILDER_METHOD_SET,
        payload: {
            method,
        },
    };
}

export function builderMethodSetCommit(payload: BuilderMethodSetActionPayload): BuilderMethodSetCommitAction {
    return {
        type: builderActionTypes.BUILDER_METHOD_SET_COMMIT,
        payload,
    };
}

export function confirmRaceSet(race: RaceDefinitionContract): ConfirmRaceSetAction {
    return {
        type: builderActionTypes.CONFIRM_RACE_SET,
        payload: {
            race,
        },
    };
}

export function confirmClassSet(charClass: ClassDefinitionContract): ConfirmClassSetAction {
    return {
        type: builderActionTypes.CONFIRM_CLASS_SET,
        payload: {
            charClass,
        },
    };
}

export function exportPdf(): ExportPdfAction {
    return {
        type: builderActionTypes.EXPORT_PDF,
        payload: {},
    };
}

export function pdfUrlSet(pdfUrl: string | null): PdfUrlSetAction {
    return {
        type: builderActionTypes.PDF_URL_SET,
        payload: {
            pdfUrl,
        },
    };
}
